module.exports = __webpack_public_path__ + "img/seo-reporter.bf60858c.jpg";